import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {Helmet} from 'react-helmet';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {getSidebarContent} from '../../Content/actions';
import ReactHtmlParser from 'react-html-parser';
import SectionTitle from '../../Layout/components/SectionTitle';
import SchoolsSearchBar from '../../Schools/components/SearchBar/SchoolsSearchBar';
import HomeAbout from './HomeAbout';
import HomeSchool from './HomeSchool';
import HomeEvents from './HomeEvents';
import LoadingSpinner from '../../Layout/components/LoadingSpinner';
import SnackbarLastNews from "../../News/components/SnackbarLastNews";

class Home extends Component {
    componentDidMount() {
        this.props.getSidebarContent('agep_home');
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.languages !== this.props.languages) {
            this.props.getSidebarContent('agep_home');
        }
    }

    render() {
        const {sidebar, loading} = this.props;

        if (sidebar.agep_home === null || sidebar.agep_home === undefined || loading) {
            return (
                <Fragment>
                    <Helmet
                        bodyAttributes={{
                            class: 'about vertical-content-force-height-100'
                        }}
                    />
                    <div className="container">
                        <div className="row mt-0 mb-0 align-items-center" style={{height: '100%'}}>
                            <div className="col-3 mx-auto">
                                <div className="text-center">
                                    <LoadingSpinner/>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
            );
        }

        let widgets = sidebar.agep_home.widgets;

        let title = <Fragment>{ReactHtmlParser(widgets.titre.data.content)}</Fragment>;

        let seoTitle = 'Association Genevoise des Ecoles Privées';
        if (widgets.hasOwnProperty('seo_title') && widgets.seo_title.data.content !== '') {
            seoTitle = widgets.seo_title.data.content;
        }

        let seoDescription = '';
        if (widgets.hasOwnProperty('seo_meta_description') && widgets.seo_meta_description.data.content !== '') {
            seoDescription = widgets.seo_meta_description.data.content;
        }

        let seoFacebookTitle = '';
        if (widgets.hasOwnProperty('seo_facebook_og_title') && widgets.seo_facebook_og_title.data.content !== '') {
            seoFacebookTitle = widgets.seo_facebook_og_title.data.content;
        }

        let seoFacebookDescription = '';
        if (widgets.hasOwnProperty('seo_facebook_og_description') && widgets.seo_facebook_og_description.data.content !== '') {
            seoFacebookDescription = widgets.seo_facebook_og_description.data.content;
        }

        let seoFacebookImage = '';
        if (widgets.hasOwnProperty('seo_facebook_og_image') && widgets.seo_facebook_og_image.data.url !== '') {
            seoFacebookImage = widgets.seo_facebook_og_image.data.url;
        }

        return (
            <Fragment>
                <Helmet
                    bodyAttributes={{
                        class: 'home header-transparent'
                    }}
                >
                    <title>{seoTitle + ' ' + process.env.REACT_APP_HEAD_TITLE_SEPARATOR + ' ' + process.env.REACT_APP_SITE_TITLE}</title>
                    {seoDescription !== '' &&
                        <meta name="description" content={seoDescription} />
                    }
                    {seoFacebookTitle !== '' &&
                        <meta property="og:title" content={seoFacebookTitle} />
                    }
                    {seoFacebookDescription !== '' &&
                        <meta property="og:description" content={seoFacebookDescription} />
                    }
                    {seoFacebookImage !== '' &&
                        <meta property="og:image" content={seoFacebookImage} />
                    }
                </Helmet>
                <div className="container">
                    <SectionTitle cssClass="home-title" title={title} subtitle={widgets.sous_titre.data.content} />

                    <SchoolsSearchBar />

                    <HomeAbout widgets={widgets}/>
                    <HomeSchool widgets={widgets}/>
                    <HomeEvents widgets={widgets}/>
                </div>
                <SnackbarLastNews />
            </Fragment>
        );
    }
}

Home.propTypes = {
    getSidebarContent: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    sidebar: state.content.sidebar,
    loading: state.content.sidebarLoading,
    errors: state.errors,
    languages: state.localize.languages,
});

export default withRouter(connect(mapStateToProps, {getSidebarContent})(Home));



// WEBPACK FOOTER //
// ./src/features/Home/components/HomeContainer.js